(function () {
    'use strict';

    // TODO: This should be a directive since we use DOM events outside of angularjs
    angular.module('app').component('habilSlider', {
        templateUrl: '@/slider/slider.html',
        bindings: {
            value: '=',
            readOnly: '=?',
            onValidated: '=?',
            objectToTransfer: '=',
            options: '<'
        },
        controller: SliderController
    });

    SliderController.$inject = ['$scope', 'translationsService', '$element', '$timeout'];
    function SliderController($scope, translationsService, $element, $timeout) {

        const defaultOptions = {
            small: false,
            showLabels: true,
            allowIndeterminate: true,
            trueLabelKey: 'Form_DropDown_Yes',
            falseLabelKey: 'Form_DropDown_No'
        };

        const track = $element[0].querySelector('.slider-parent');
        
        const $controller = this;

        // Lifecycle hooks
        $controller.$onInit = initialize;
        $controller.$onChanges = handleOneWayBindingChanges;

        // DOM event handlers
        $controller.ClickLabel = setValue;

        $scope.$watch('$ctrl.value', (newV) => {
            if (newV === undefined || $controller.readOnly)
                return;
            setValue(newV);
        });

        /**
         * Update the value when the track is clicked (value depends on the location of the click)
         * @param {MouseEvent} event The event
         */
        function onTrackClicked(event) {
            if ($controller.readOnly) return;

            const rect = event.target.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const clickedLeft = (track.offsetWidth / 2) > x;

            $scope.$apply(() => {
                $controller.value = !clickedLeft;
                executeCallback($controller.value);
            });
        }
        /**
         * Invokes the onValidated callback
         * @param {Boolean} value the new value
         */
        function executeCallback(value) {
            if (angular.isFunction($controller.onValidated)) {
                // Delay the callback until the next digest cycle, otherwise the data on the object is not updated
                // The reason for this is that while we update $scope.value, this does not necessarily happen before 
                // a digest cycle is active. Therefore it needs to be triggered in the next cycle (to make sure).
                $timeout(() => $controller.onValidated(value, $controller.objectToTransfer));
            }
        };

        function setValue(value) {
            if ($controller.readOnly || $controller.value === value)
                return;

            $controller.value = value;
            executeCallback($controller.value);
        }

        $scope.GetSliderParentClass = () => {

            const classes = [];

            if ($controller.privateOptions.small)
                classes.push('slider-parent-80percent');

            if ($controller.readOnly)
                classes.push('read-only');

            if ($controller.value === false)
                classes.push('invalid');
            else if ($controller.value === true)
                classes.push('valid');
            else
                classes.push('indeterminate');

            return classes.join(' ');
        };

        // Lifecycle hook implementation

        function initialize() {

            if (!$controller.privateOptions)
                $controller.privateOptions = { ...defaultOptions };

            // Load translations + title
            translationsService.loadTranslations(t => {
                $controller.translations = t;
            });

            track.onclick = onTrackClicked;
        }

        function handleOneWayBindingChanges(changes) {
            if (changes.options) {
                // Merge options with defaults and store in separate item if options have been given
                if (angular.isObject($controller.options))
                    $controller.privateOptions = { ...defaultOptions, ...$controller.options };
                else
                    $controller.privateOptions = { ...defaultOptions };
            }
        }
    }
})();
